import "./App.css";
import { useEffect, useState } from "react";

//import components
import Navbar from "./components/Navbar";
import Intro from "./components/Intro";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Responsive from "./components/Responsive";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";
import PreLoader from "./components/PreLoader";

function App() {
  const [resumeData, setResumeData] = useState([]);

  const getData = () => {
    fetch("/resumeData.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((myJson) => {
        console.log(myJson);
        setResumeData(myJson);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Intro />
      <About data={resumeData.about} />
      <Portfolio />
      <Responsive />
      <Contact />
      <Footer />
      <BackTop />
      <PreLoader />
    </div>
  );
}

export default App;
